import extractPlainText from "@Pages/Blog/Author/utils/extractPlainText";
import getBlogImageUrl from "@Pages/Blog/utils/getBlogImageUrl";
import {
  ORGANIZATION_ID,
  SITE_URL,
  WEBSITE_ID,
  getContributorRef,
  getPersonNode,
  isPersonContributor,
  toSchemaGraph,
} from "@Pages/Blog/utils/blogSchemaGraph";

const getNewBlogPostSchema = (blogData: any, slug: string, lang?: string) => {
  const blogUrl = `${SITE_URL}${lang ? `/${lang}` : ""}/blog`;
  const pageUrl = `${blogUrl}/${slug}`;
  const datePublished = blogData.date || blogData.createdAt;
  const dateModified = blogData.updatedAt || blogData.date;
  const { writer, reviewer } = blogData;

  const people = [writer, reviewer]
    .filter(isPersonContributor)
    .filter((person, index, list) => list.findIndex((p) => p.slug === person.slug) === index)
    .map(getPersonNode);

  const faqQuestions = (blogData.faqItems || [])
    .map((item: any) => ({
      question: item?.question,
      answer: extractPlainText(item?.answerRichText) || item?.answer,
    }))
    .filter((item: any) => item.question && item.answer)
    .map((item: any) => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: { "@type": "Answer", text: item.answer },
    }));

  return toSchemaGraph([
    {
      "@type": "WebPage",
      "@id": `${pageUrl}#webpage`,
      url: pageUrl,
      name: blogData.metaTitle || blogData.name,
      isPartOf: { "@id": WEBSITE_ID },
      breadcrumb: { "@id": `${pageUrl}#breadcrumb` },
      datePublished,
      dateModified,
      reviewedBy: getContributorRef(reviewer),
    },
    {
      "@type": "BlogPosting",
      "@id": `${pageUrl}#article`,
      mainEntityOfPage: { "@id": `${pageUrl}#webpage` },
      headline: blogData.name,
      ...(blogData.metaDescription ? { description: blogData.metaDescription } : {}),
      ...(blogData.mainImage?.url ? { image: [getBlogImageUrl(blogData.mainImage.url)] } : {}),
      datePublished,
      dateModified,
      author: getContributorRef(writer),
      publisher: { "@id": ORGANIZATION_ID },
    },
    {
      "@type": "BreadcrumbList",
      "@id": `${pageUrl}#breadcrumb`,
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "Home", item: `${SITE_URL}/` },
        { "@type": "ListItem", position: 2, name: "Blogs", item: blogUrl },
        { "@type": "ListItem", position: 3, name: blogData.name },
      ],
    },
    ...people,
    ...(faqQuestions.length
      ? [{ "@type": "FAQPage", "@id": `${pageUrl}#faq`, mainEntity: faqQuestions }]
      : []),
  ]);
};

export default getNewBlogPostSchema;
